export const categoryTranslations = {
    en: {
        // Categories
        categories: 'Categories',
        categoriesDescription: 'Manage your menu categories and organize your items',
        categoryName: 'Category Name',
        categoryNameAr: 'Category Name (Arabic)',
        categorySlug: 'Category Slug',
        categoryIcon: 'Category Icon',
        categoryStatus: 'Status',
        categoryActive: 'Active',
        categoryInactive: 'Inactive',
        addCategory: 'Add Category',
        editCategory: 'Edit Category',
        editCategoryDescription: 'Update category information and settings',
        confirmDeleteCategory: 'Are you sure you want to delete this category?',
        errorLoadingCategories: 'Failed to load categories',
        errorLoadingCategory: 'Failed to load category',
        errorDeletingCategory: 'Failed to delete category',
        errorUpdatingCategory: 'Failed to update category',
        deletingCategory: 'Deleting category...',
        categoryDeleted: 'Category deleted successfully',
        updatingCategory: 'Updating category...',
        categoryUpdated: 'Category updated successfully',
        noCategoriesFound: 'No categories found. Create your first category!',
        noMatchingCategories: 'No matching categories found',
        searchCategories: 'Search categories...',
        allStatuses: 'All Statuses',
        sortByOrder: 'Sort by Order',
        sortByName: 'Sort by Name',
        enterCategoryName: 'Enter category name in English',
        enterCategoryNameAr: 'Enter category name in Arabic',
        enterSlug: 'Enter URL slug',
        enterSortOrder: 'Enter sort order number',
        backToCategories: 'Back to Categories',
        createCategory: 'Create Category',
        createCategoryDesc: 'Add a new category to your menu',
        categoryCreated: 'Category created successfully',
        creating: 'Creating...',
        errorOccurred: 'An error occurred while creating the category'
    },
    ar: {
        // Categories
        categories: 'الأقسام',
        categoriesDescription: 'إدارة فئات القائمة وتنظيم المنتجات',
        categoryName: 'اسم القسم',
        categoryNameAr: 'اسم القسم (بالعربية)',
        categorySlug: 'رابط القسم',
        categoryIcon: 'أيقونة القسم',
        categoryStatus: 'الحالة',
        categoryActive: 'نشط',
        categoryInactive: 'غير نشط',
        addCategory: 'إضافة قسم',
        editCategory: 'تعديل القسم',
        editCategoryDescription: 'تحديث معلومات وإعدادات القسم',
        confirmDeleteCategory: 'هل أنت متأكد من حذف هذه القسم؟',
        errorLoadingCategories: 'فشل في تحميل الأقسام',
        errorLoadingCategory: 'فشل في تحميل القسم',
        errorDeletingCategory: 'فشل في حذف القسم',
        errorUpdatingCategory: 'فشل في تحديث القسم',
        deletingCategory: 'جاري حذف القسم...',
        categoryDeleted: 'تم حذف القسم بنجاح',
        updatingCategory: 'جاري تحديث القسم...',
        categoryUpdated: 'تم تحديث القسم بنجاح',
        noCategoriesFound: 'لا توجد فئات. قم بإنشاء أول قسم!',
        noMatchingCategories: 'لا توجد فئات مطابقة للبحث',
        searchCategories: 'البحث في الأقسام...',
        allStatuses: 'جميع الحالات',
        sortByOrder: 'ترتيب حسب الترتيب',
        sortByName: 'ترتيب حسب الاسم',
        enterCategoryName: 'أدخل اسم القسم بالإنجليزية',
        enterCategoryNameAr: 'أدخل اسم القسم بالعربية',
        enterSlug: 'أدخل الرابط المختصر',
        enterSortOrder: 'أدخل رقم الترتيب',
        backToCategories: 'العودة إلى الأقسام',
        createCategory: 'إضافة قسم',
        createCategoryDesc: 'إضافة قسم جديدة إلى القائمة',
        categoryCreated: 'تم إنشاء القسم بنجاح',
        creating: 'جاري الإنشاء...',
        errorOccurred: 'حدث خطأ أثناء إنشاء القسم'
    }
};
